var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 4.99998H4.66667V0.333313H3.33334V4.99998H2.00001V0.333313H0.666672V4.99998C0.666672 6.41331 1.77334 7.55998 3.16667 7.64665V13.6666H4.83334V7.64665C6.22667 7.55998 7.33334 6.41331 7.33334 4.99998V0.333313H6.00001V4.99998ZM9.33334 2.99998V8.33331H11V13.6666H12.6667V0.333313C10.8267 0.333313 9.33334 1.82665 9.33334 2.99998Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 4.99998H4.66667V0.333313H3.33334V4.99998H2.00001V0.333313H0.666672V4.99998C0.666672 6.41331 1.77334 7.55998 3.16667 7.64665V13.6666H4.83334V7.64665C6.22667 7.55998 7.33334 6.41331 7.33334 4.99998V0.333313H6.00001V4.99998ZM9.33334 2.99998V8.33331H11V13.6666H12.6667V0.333313C10.8267 0.333313 9.33334 1.82665 9.33334 2.99998Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodService);
export default __webpack_public_path__ + "static/media/FoodService.059bb454d87606eb6435cfa5e73beabd.svg";
export { ForwardRef as ReactComponent };